import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';
import { useOrgStore } from '.';
import { loadCampuses, loadMinistries } from './actions';
import { useApiWithAuth } from '@/hooks/api';
import { useAuth } from '@/hooks/auth';

export function useCampuses(force = false) {
  const store = useOrgStore();
  const { api, auth } = useApiWithAuth();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (store.loaded.campuses.current && !force) {
      return;
    }

    setLoading(true);

    loadCampuses(store, { api, force, auth })
      .then(() => {
        setLoading(false);

        return;
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, [store, auth, api, force]);

  return {
    list: store.computed.campusesList,
    lookup: store.state.campuses.data,
    loading,
  };
}

export function useSharedCampusState(): [
  string[],
  Dispatch<SetStateAction<string[]>>,
] {
  const auth = useAuth();
  const init = [(auth.userMetadata?.data.campus_id || '') as string];
  const [campus, setCampus] = useState(init);

  return [campus, setCampus];
}

export function useDefaultCampus() {
  const auth = useAuth();

  return (auth.userMetadata?.data.campus_id || '') as string;
}

export function useMinistries(force = false) {
  const store = useOrgStore();
  const { api, auth } = useApiWithAuth();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (store.loaded.ministries.current && !force) {
      return;
    }

    setLoading(true);

    loadMinistries(store, { api, force, auth })
      .then(() => {
        setLoading(false);

        return;
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, [store, auth, api, force]);

  return {
    list: store.state.ministries.data,
    lookup: store.computed.ministriesLookup,
    loading,
  };
}
